import { Base } from '../base'
import { Ingredient } from '../../types/types'

const resourceName = 'ingredients'

export class IngredientsApi extends Base {

    async fetchIngredients(): Promise<Ingredient[]> {
        return await this.request(`${resourceName}`)
    }

    async updateIngredient(ingredient: Ingredient) : Promise<Ingredient> {
        return await this.request(`${resourceName}/${ingredient.id}`, {
            body: JSON.stringify(ingredient),
            method: 'post'
        })
    }

}